export enum WidgetEvent {
  CALL_QUIZ = "call_quiz",
  CLOSE_WIDGET = 'close_widget'
}